import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumOneFreePeriod implements BaseEnumType {
  private static allValues: EnumOneFreePeriod[] = []; // make sure this is top-most
  
  public static day = new EnumOneFreePeriod(100, "Day", "enum_one_free_period_day");
  public static month = new EnumOneFreePeriod(109, "Month", "enum_one_free_period_month");
  public static week = new EnumOneFreePeriod(119, "Week", "enum_one_free_period_week");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumOneFreePeriod.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isDay() { return this === EnumOneFreePeriod.day; }
  public isMonth() { return this === EnumOneFreePeriod.month; }
  public isWeek() { return this === EnumOneFreePeriod.week; }

  public static getValues(): readonly EnumOneFreePeriod[] {
    return EnumOneFreePeriod.allValues;
  }

  public static getValuesExcept0(): readonly EnumOneFreePeriod[] {
    return EnumOneFreePeriod.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumOneFreePeriod {
    const found = EnumOneFreePeriod.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumOneFreePeriod - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumOneFreePeriod): EnumOneFreePeriod {
    const found = name ? EnumOneFreePeriod.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumOneFreePeriod - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumOneFreePeriod>): boolean {
    return this.key === other?.key;
  }
}